import React from 'react';
import { useAppDispatch } from '@/store/hooks';
import { updateUser } from '@/store/slices/authSlice';
import { authAPI } from '@/services/authAPI';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    // Initialize auth state from localStorage
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');

    if (storedUser && storedToken) {
      try {
        const user = JSON.parse(storedUser);
        dispatch(updateUser(user));
      } catch (error) {
        console.error('Error parsing stored user data:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
      }

      // Fetch fresh profile to sync fields like phone
      authAPI.getCurrentProfile().then((result) => {
        if (result.success && result.user) {
          dispatch(updateUser(result.user));
        }
      }).catch(() => {
        // Silently fail — stale localStorage data is still usable
      });
    }
  }, [dispatch]);

  return <>{children}</>;
};